// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-grid-item {
  background: #eee;
  /* border: 1px solid #bada55; */
}

.react-grid-item.react-grid-placeholder {
  background: rgba(255, 193, 193, 0.5);
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/DashboardLayout/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb","sourcesContent":[":global(.react-grid-item) {\n  background: #eee;\n  /* border: 1px solid #bada55; */\n}\n\n:global(.react-grid-item.react-grid-placeholder) {\n  background: rgba(255, 193, 193, 0.5);\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
